module.exports = __webpack_public_path__ + "img/versorgungsheim.0fc5592c.jpg";